import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import { StyledLoadingMaskSpinner } from './LoadingMaskSpinner.styles';

/**
 * @since 8.1.0
 */
export var LoadingMaskSpinner = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledLoadingMaskSpinner, _extends({
    ref: forwardedRef
  }, props));
});
LoadingMaskSpinner.displayName = 'LoadingMaskSpinner';